import Dot from '../Dot/View/Dot.view';
export default Dot;
